export default __webpack_public_path__ + "static/media/B_lopetus4.dbc2c87d.mp3";